import { render, staticRenderFns } from "./Deneme2.vue?vue&type=template&id=6647a1f6&"
import script from "./Deneme2.vue?vue&type=script&lang=js&"
export * from "./Deneme2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports